module.exports = __webpack_public_path__ + "img/profile.12bfde48.jpg";